import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "uk-container uk-background-default" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "uk-alert-warning",
  "uk-alert": ""
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { "uk-flex": "" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "uk-background-sections rel"
}
const _hoisted_10 = { "uk-switcher": "animation: uk-animation-fade; toggle: > *" }
const _hoisted_11 = {
  class: "uk-button uk-button-default",
  type: "button"
}
const _hoisted_12 = { class: "uk-badge" }
const _hoisted_13 = {
  class: "uk-button uk-button-default",
  type: "button"
}
const _hoisted_14 = { class: "uk-switcher uk-margin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnterLoad = _resolveComponent("EnterLoad")!
  const _component_LoadsTable = _resolveComponent("LoadsTable")!
  const _component_DriversTable = _resolveComponent("DriversTable")!
  const _component_Customers = _resolveComponent("Customers")!
  const _component_CreateDriverModal = _resolveComponent("CreateDriverModal")!
  const _component_CreateCustomerModal = _resolveComponent("CreateCustomerModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.errorText), 1),
    (_ctx.mainLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("div", { "uk-spinner": "ratio: 3" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_ctx.hasPodOperator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("p", null, " This page is available only for POD Tracking operators. Please contact support to enable access for your account. ", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: "uk-button uk-button-large uk-button-primary uk-form-controls",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowAddNewLoad=!_ctx.isShowAddNewLoad))
                    }, [
                      (_ctx.isShowAddNewLoad)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("span", { "uk-icon": "icon: minus" }, null, -1),
                            _createTextVNode("Close", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[10] || (_cache[10] = [
                            _createElementVNode("span", { "uk-icon": "icon: plus" }, null, -1),
                            _createTextVNode("New Load", -1)
                          ]))]))
                    ]),
                    _createVNode(_Transition, { name: "slide" }, {
                      default: _withCtx(() => [
                        (_ctx.isShowAddNewLoad)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("button", {
                                class: "uk-close-large close-btn",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowAddNewLoad=false)),
                                "uk-close": ""
                              }),
                              _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "mt-0" }, "Add new load", -1)),
                              _createVNode(_component_EnterLoad, {
                                onAddedLoad: _ctx.refreshUserData,
                                onCreatedDriver: _ctx.refreshUserData,
                                onOpenCreateDriver: _ctx.openCreateDriverModal,
                                onOpenCreateCustomer: _ctx.openCreateCustomerModal,
                                drivers: _ctx.drivers,
                                customers: _ctx.customers
                              }, null, 8, ["onAddedLoad", "onCreatedDriver", "onOpenCreateDriver", "onOpenCreateCustomer", "drivers", "customers"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _cache[14] || (_cache[14] = _createElementVNode("h2", null, "My Loads", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", _hoisted_11, [
                        _cache[12] || (_cache[12] = _createTextVNode(" Active ", -1)),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.activeLoads.length), 1)
                      ]),
                      _createElementVNode("button", _hoisted_13, [
                        _cache[13] || (_cache[13] = _createTextVNode(" Archived ", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["uk-badge", {'uk-label-black':_ctx.archivedLoads.length > 0}])
                        }, _toDisplayString(_ctx.archivedLoads.length), 3)
                      ])
                    ]),
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_LoadsTable, {
                          onRefreshLoads: _ctx.refreshUserData,
                          onArchiveLoad: _ctx.archiveLoad,
                          loads: _ctx.activeLoads,
                          user: _ctx.user,
                          tableType: "active",
                          condensed: _ctx.user.enableCustomerInfo != true
                        }, null, 8, ["onRefreshLoads", "onArchiveLoad", "loads", "user", "condensed"])
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_LoadsTable, {
                          onRefreshLoads: _ctx.refreshUserData,
                          onUnarchiveLoad: _ctx.unarchiveLoad,
                          loads: _ctx.archivedLoads,
                          user: _ctx.user,
                          tableType: "archived",
                          condensed: _ctx.user.enableCustomerInfo != true
                        }, null, 8, ["onRefreshLoads", "onUnarchiveLoad", "loads", "user", "condensed"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "uk-button uk-button-default",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshUserData && _ctx.refreshUserData(...args)))
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("span", { "uk-icon": "refresh" }, null, -1),
                      _createTextVNode(" Refresh All Load Data", -1)
                    ]))])
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "uk-divider-icon" }, null, -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("h2", null, "My Drivers", -1)),
                  _createElementVNode("button", {
                    class: "uk-button uk-button-primary",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCreateDriverModal && _ctx.showCreateDriverModal(...args)))
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("div", { "uk-icon": "icon: plus" }, null, -1),
                    _createTextVNode(" Add new driver", -1)
                  ]))]),
                  _createVNode(_component_DriversTable, { drivers: _ctx.drivers }, null, 8, ["drivers"]),
                  _cache[20] || (_cache[20] = _createElementVNode("h2", null, "My Customers", -1)),
                  _createElementVNode("button", {
                    class: "uk-button uk-button-primary",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showCreateCustomerModal && _ctx.showCreateCustomerModal(...args)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("div", { "uk-icon": "icon: plus" }, null, -1),
                    _createTextVNode(" Add new customer", -1)
                  ]))]),
                  _createVNode(_component_Customers, {
                    module: 'POD',
                    ref: "customersComp",
                    onCreatedCustomer: _ctx.updateCustomersChild
                  }, null, 8, ["onCreatedCustomer"]),
                  _createVNode(_component_CreateDriverModal, {
                    open: _ctx.isCreateDriverOpen,
                    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCreateDriverOpen = false)),
                    onCreatedDriver: _ctx.refreshUserData
                  }, null, 8, ["open", "onCreatedDriver"]),
                  _createVNode(_component_CreateCustomerModal, {
                    isOpen: _ctx.isCreateCustomerOpen,
                    "onUpdate:isOpen": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCreateCustomerOpen) = $event)),
                    onCreatedCustomer: _ctx.refreshUserData
                  }, null, 8, ["isOpen", "onCreatedCustomer"])
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1))
              ]))
        ]))
  ]))
}